import {
  type AvatarBaseProps,
  type AvatarIconProps,
  Avatar as DSAvatar,
  type AvatarImageProps as DSAvatarImageProps,
} from "@opensea/ui-kit"
import type { ComponentProps, ComponentPropsWithoutRef } from "react"
import { Image } from "../Image"

type BaseAvatarImageProps = DSAvatarImageProps &
  ComponentPropsWithoutRef<typeof Image>

export type AvatarProps =
  | Omit<BaseAvatarImageProps, "height" | "width">
  | AvatarIconProps
  | AvatarBaseProps

type AvatarImageProps = ComponentProps<NonNullable<AvatarProps["renderImage"]>>

export function AvatarImage({ size, ...rest }: AvatarImageProps) {
  return <Image height={size} width={size} {...rest} />
}

export function Avatar(props: AvatarProps) {
  return <DSAvatar {...props} renderImage={AvatarImage} />
}
